<script lang="ts">
  import { fly, slide } from "svelte/transition";

  import MediaQuery from "./MediaQuery.svelte";
  export let GameName: string;
  export let show_chat: boolean;
</script>

<div in:fly={{ y: 140, duration: 800 }} class="outter">
  <div class="inner">
    <div class="everything">
      <div>
        <h1 class="title">{GameName}</h1>
        <slot name="topper" />
      </div>

      <MediaQuery query="(min-width: 785px)" let:matches>
        {#if !matches && show_chat}
          <slot name="chat" />
        {:else}
          <slot name="overlay" />

          <slot name="game" />
        {/if}

        <slot name="footer" />
        <slot name="bottom-bar" />
      </MediaQuery>
    </div>

    <MediaQuery query="(min-width: 785px)" let:matches>
      {#if matches && show_chat}
        <span
          in:slide={{ duration: 400 }}
          out:slide={{ duration: 150 }}
          style="margin-left: 1rem"
        >
          <slot name="chat" />
        </span>
      {/if}
    </MediaQuery>
  </div>
</div>

<style>
  .title {
    margin: 0;
    user-select: none;
  }

  .outter {
    height: 100vh;
    display: flex;
    align-content: center;
    overflow: hidden;
  }

  .inner {
    text-align: center;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .everything {
    margin-top: -5rem;
  }

  /* .board {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(7, 50px);
    grid-template-rows: repeat(6, 50px);
  } */
</style>
